// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"163":"docs","323":"oxc-me","557":"oxc-home"}[chunkId] || chunkId) + "." + {"163":"2437f726","323":"a585506f","557":"d6c9fff9","614":"a512a85e"}[chunkId] + ".js";
};